/**
 * @license
 * Copyright Endlessjs. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */

import { InjectionToken } from '@angular/core';
import { ElMediaBreakpoint } from './services/breakpoints.service';
import { ElJSThemeOptions } from './services/js-themes/theme.options';

export interface ElThemeOptions {
  name: string;
}

export const EL_THEME_OPTIONS = new InjectionToken<ElThemeOptions>('Endlessjs Theme Options');
export const EL_MEDIA_BREAKPOINTS = new InjectionToken<ElMediaBreakpoint[]>('Endlessjs Media Breakpoints');
export const EL_BUILT_IN_JS_THEMES = new InjectionToken<ElJSThemeOptions[]>('Endlessjs Built-in JS Themes');
export const EL_JS_THEMES = new InjectionToken<ElJSThemeOptions[]>('Endlessjs JS Themes');

/**
 * We're providing browser apis with tokens to improve testing capabilities.
 * */
export const EL_WINDOW = new InjectionToken<Window>('Window');
export const EL_DOCUMENT = new InjectionToken<Document>('Document');
